import React, { createContext, useContext, useState, useEffect, useMemo } from 'react';
import * as mockPt from '../data/mock';
import * as mockEn from '../data/mockEn';

const LanguageContext = createContext();

export const LanguageProvider = ({ children }) => {
  const [language, setLanguage] = useState('pt');
  const [theme, setTheme] = useState('light');

  const toggleLanguage = () => {
    setLanguage(prev => prev === 'pt' ? 'en' : 'pt');
  };

  const toggleTheme = () => {
    setTheme(prev => prev === 'light' ? 'dark' : 'light');
  };

  useEffect(() => {
    if (theme === 'dark') {
      document.documentElement.setAttribute('data-theme', 'dark');
    } else {
      document.documentElement.removeAttribute('data-theme');
    }
  }, [theme]);

  const data = useMemo(() => {
    return language === 'pt' ? mockPt : mockEn;
  }, [language]);

  return (
    <LanguageContext.Provider value={{ language, toggleLanguage, theme, toggleTheme, ...data }}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLanguage = () => useContext(LanguageContext);
